import store from "store/store"

export const updateUserDetail = (user) => {
    store.dispatch({
        type: 'USER_DETAIL',
        value: user
    })
}

// Dashboard/index.jsx, UserSideContext.js and Home/index.jsx each fetch the
// merchant profile (AUTH.ME) independently on mount, into different state
// systems (Redux / Context / local) — they don't need three separate network
// calls for the same data landing within moments of each other. The in-flight
// promise above collapses truly concurrent callers, but confirmed via HAR +
// live Playwright testing (2026-07-23): these three mounts fire sequentially,
// a few hundred ms apart, not concurrently — by the time the second one asks,
// the first has already resolved and cleared the in-flight slot, so it still
// triggers its own fetch. A short-TTL cache of the last resolved response
// closes that gap: any call within CACHE_TTL_MS of the previous one's
// resolution reuses that result instead of re-hitting the network.
//
// This has to live on `window` rather than a module-level variable: Dashboard
// is lazy-loaded (its own webpack chunk) while UserSideContext.js ships in
// the main bundle, so webpack can end up giving each chunk its own copy of
// this module — a plain module-level variable would silently stop being
// shared between them. `window` is the one thing guaranteed to be the same
// single instance no matter how the code gets split into chunks.
const IN_FLIGHT_KEY = "__merchantProfileInFlight";
const LAST_RESULT_KEY = "__merchantProfileLastResult";
const LAST_RESULT_AT_KEY = "__merchantProfileLastResultAt";
const CACHE_TTL_MS = 3000;

export const fetchMerchantProfileShared = (axiosInstance, apiRoute) => {
    if (window[IN_FLIGHT_KEY]) return window[IN_FLIGHT_KEY];

    if (
        window[LAST_RESULT_KEY] &&
        window[LAST_RESULT_AT_KEY] &&
        Date.now() - window[LAST_RESULT_AT_KEY] < CACHE_TTL_MS
    ) {
        return window[LAST_RESULT_KEY];
    }

    const promise = axiosInstance
        .get(apiRoute, { offlineCache: true })
        .then((res) => {
            window[LAST_RESULT_KEY] = Promise.resolve(res);
            window[LAST_RESULT_AT_KEY] = Date.now();
            return res;
        })
        .finally(() => {
            window[IN_FLIGHT_KEY] = null;
        });
    window[IN_FLIGHT_KEY] = promise;
    return promise;
}
